export default __webpack_public_path__ + "static/media/a033.3fc729b7.png";